import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * When a column contains multiple cell configs then this particular Renderer is responsible
 * for deciding which cell config to render and then renders the component in that config.
 * Note: If multiple cell configs have should render returning as true, then the first one is picked up.
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
var MultiCellRenderer = /*#__PURE__*/function (_PureComponent) {
  _inherits(MultiCellRenderer, _PureComponent);
  var _super = _createSuper(MultiCellRenderer);
  function MultiCellRenderer() {
    var _this;
    _classCallCheck(this, MultiCellRenderer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    /**
     * Find the active configuration for this particular cell.
     * First gets the cell config array for this column, then iterate over the configs to finc the active one.
     */
    _defineProperty(_assertThisInitialized(_this), "getConfig", function () {
      var cellConfigurationMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
      var columnId = _get(_this.props, 'column.id');
      var cellConfigForColumn = cellConfigurationMap[columnId];
      if (cellConfigForColumn) {
        return cellConfigForColumn.find(_this.shouldRenderConfiguration);
      }
      return undefined;
    });
    /**
     * Gets the shouldRender function from the cellConfig and then executes it with the cell props
     * to find whether to render the configuration or not.
     */
    _defineProperty(_assertThisInitialized(_this), "shouldRenderConfiguration", function () {
      var cellConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
      /**
       * Default value is not needed here as it is handled by the builder.
       * If the code breaks for someone here, then as per design it should as the person is not using the builder.
       */
      var shouldRender = cellConfig.shouldRender;
      // The below function should always return a boolean as suggested by name.
      return shouldRender(_this.props);
    });
    return _this;
  }
  _createClass(MultiCellRenderer, [{
    key: "renderCellConfig",
    value:
    /**
     * Extracts the component from the config.
     * If the component is present then render the Renderer mentioned in the config.
     */
    function renderCellConfig() {
      var cellConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
      var Component = cellConfig.component;

      // This is needed as there are some cases where we dont need to render anything in a cell.
      if (!Component) {
        return null;
      }
      return /*#__PURE__*/React.createElement(Component, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var cellConfigurationMap = _get(this.props, 'tdProps.rest.cellConfigurationMap');

      // Get the cell configuration to render fow the particular row.
      var cellConfig = this.getConfig(cellConfigurationMap);

      // If no cell config is found then just render nothing
      if (!cellConfig) {
        return null;
      }

      // If a cell config is found then render the cell config.
      return this.renderCellConfig(cellConfig);
    }
  }]);
  return MultiCellRenderer;
}(PureComponent);
MultiCellRenderer.propTypes = {
  cellConfigurationMap: PropTypes.object.isRequired
};
export default MultiCellRenderer;